var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_6588)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84409 20.5551L14.3185 26.0312C14.5645 26.2774 14.9336 26.2774 15.1796 26.0312L28.8348 12.3101C29.0808 12.064 29.0808 11.6948 28.8348 11.4487L23.4219 6.03404C23.1759 5.78792 22.8068 5.78792 22.5608 6.03404L8.84409 19.7552C8.59805 20.0013 8.59805 20.3705 8.84409 20.5551ZM25.2055 3.51147C24.9595 3.75759 24.9595 4.12677 25.2055 4.37289L30.6184 9.78751C30.8645 10.0336 31.2335 10.0336 31.4796 9.78751L33.0173 8.24927C34.0015 7.32632 34.0015 5.8496 33.0173 4.86512L30.1263 1.97322C29.1422 0.988744 27.6044 0.988744 26.6203 1.97322L25.2055 3.51147ZM4.29242 29.6617C4.1694 30.277 4.72298 30.8307 5.33808 30.7077L12.0427 29.1079C12.2887 29.0464 12.4732 28.9233 12.5962 28.8003L12.7193 28.6772C12.8423 28.5541 12.9038 28.1234 12.6578 27.8773L7.12187 22.3396C6.87583 22.0935 6.44526 22.155 6.32224 22.2781L6.19922 22.4012C6.01469 22.5857 5.95318 22.7703 5.89167 22.9549L4.29242 29.6617Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_6588",
    x: -1,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_6588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_6588",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenWhite);
export default __webpack_public_path__ + "static/media/edit-pen-white.b417497e52e0cf0033a4d5fa6b67a729.svg";
export { ForwardRef as ReactComponent };